import styled from "styled-components";

export const Wrapper = styled.section`
  display: flex;
`;
